import DataModule from "@/components/DataModule";

export default function Employees() {
  return (
    <DataModule
      title="Employees"
      subtitle="Staff, daily wages and project assignments"
      endpoint="employees"
      pageTestId="employees-page"
      fields={[
        { key: "name", label: "Name", required: true },
        { key: "phone", label: "Phone" },
        { key: "email", label: "Email", type: "email" },
        { key: "role", label: "Role / Designation" },
        { key: "salary", label: "Monthly Salary", type: "number" },
        { key: "daily_wage", label: "Daily Wage", type: "number" },
        { key: "joining_date", label: "Joining Date", type: "date" },
        { key: "address", label: "Address", type: "textarea", full: true },
      ]}
      columns={[
        { key: "name", label: "Name", render: (e) => <span className="font-medium">{e.name}</span> },
        { key: "role", label: "Role" },
        { key: "phone", label: "Phone" },
        { key: "salary", label: "Salary" },
      ]}
    />
  );
}
